import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import BannerSkeleton from './BannerSkeleton';

const DealershipBanner = dynamic(
  () => import(/* webpackChunkName: "DealershipBanner" */ '@/dealership/Banner')
);

const PromoBanner = dynamic(
  () => import(/* webpackChunkName: "PromoBanner" */ './PromoBanner')
);

function Banner() {
  const isDealership = useIsDealershipPage();

  // These banners are server-rendered (ssr: true). The local Suspense boundary
  // catches their hydration suspense (the lazy chunk may still be downloading
  // on a slow connection) so it stays contained to the banner area instead of
  // bubbling to the SRP route boundary and collapsing the whole page.
  return (
    <Suspense fallback={<BannerSkeleton />}>
      {isDealership ? <DealershipBanner /> : <PromoBanner />}
    </Suspense>
  );
}

export default withErrorBoundary(Banner, { section: 'Banner' });
